import ApiService from "@/core/services/api.service";
// action types
export const IOT_CREATE_DATA = "iotData";
export const PUT_IOT_DATA = "putIotData";
export const GET_IOT_DATA = "getIotData";
export const SET_STATE_PRAM_IOT = "setStarePramIot";

export default {
  state: {
    path: "iot"
  },
  getters: {},
  actions: {
    [IOT_CREATE_DATA](context, payload) {
        ApiService.setHeader();
        return ApiService.post(`${context.state.path}`, payload.data);
      },
      [PUT_IOT_DATA](context, payload) {
        ApiService.setHeader();
        return ApiService.put(
          `${context.state.path}/update/iot/${payload.id}`,
          payload.data
        );
      },
      [GET_IOT_DATA](context, payload) {
        ApiService.setHeader();
        return ApiService.getParams(`${context.state.path}/${payload.id}`);
      },
  },
  mutations: {
    [SET_STATE_PRAM_IOT](state, payload) {
      state.data_pram = payload;
    },
  }
};
